// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1Z_fQ","disabled":"FileBtn_disabled__15-Vu","warn":"FileBtn_warn__3PwsC","fade":"FileBtn_fade__3upJP"};